type Props = {
  className?: string;
};

export const Auction = ({ className }: Props) => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Gavel">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.17703 9.20174L9.90969 8.46908L11.7284 6.65045L12.461 5.91778L10.9496 4.40634C10.5449 4.81096 9.8889 4.81096 9.48427 4.40634L8.05695 2.97901C7.65232 2.57439 7.65232 1.91837 8.05695 1.51374L6.54321 5.81626e-06L3.25924 3.28397L4.77298 4.79771C5.17762 4.39307 5.8388 4.39818 6.24344 4.80282L1.26422 9.78204L2.67901 11.1968L7.65822 6.21761C8.06286 6.62225 8.07023 7.28566 7.66559 7.6903L9.17703 9.20174Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
